<template>
  <div
    id="kt_aside"
    class="aside aside-hoverable aside-dark"
    data-kt-drawer="true"
    data-kt-drawer-activate="{default: true, lg: false}"
    data-kt-drawer-direction="start"
    data-kt-drawer-name="aside"
    data-kt-drawer-overlay="true"
    data-kt-drawer-toggle="#kt_aside_mobile_toggle"
    data-kt-drawer-width="{default:'200px', '300px': '250px'}"
    v-if="!hasRole('ROLE_FORMS_MOBILE')"
  >
    <div
      id="kt_aside_logo"
      class="aside-logo flex-column-auto"
    >
      <router-link to="/">
        <img
          alt="Logo"
          class="h-15px logo"
          :src="logoSrc"
        >
      </router-link>

      <!-- Mobile close button -->
      <button
        id="kt_aside_mobile_close"
        class="btn btn-mobile-close d-lg-none"
        type="button"
        aria-label="Zamknij menu"
        @click="closeMobileMenu"
      >
        <i class="bi bi-x-lg" />
      </button>

      <!-- Desktop toggle button -->
      <div
        id="kt_aside_toggle"
        class="btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle d-none d-lg-flex"
        data-kt-toggle="true"
        data-kt-toggle-name="aside-minimize"
        data-kt-toggle-state="active"
        data-kt-toggle-target="body"
      >
        <span class="svg-icon svg-icon-1 rotate-180">
          <inline-svg src="/img/navigation/angle-double-left.svg" />
        </span>
      </div>
    </div>
    <div class="aside-menu flex-column-fluid">
      <Menu />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUpdated, computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { DrawerComponent } from '@/assets/ts/components/_DrawerComponent'
import { ToggleComponent } from '@/assets/ts/components/_ToggleComponent'
import Menu from '@/components/header/Menu.vue'
import {hasRole} from "@/utils/tools";
import { getClientBrandingLogo } from '@/utils/client-branding'

export default defineComponent({
  name: 'Aside',
  components: { Menu },
  setup() {
    const { t } = useI18n()
    const isDarkMode = ref(false)

    const checkDarkMode = () => {
      isDarkMode.value = document.body.classList.contains('dark-theme')
    }

    const logoSrc = computed(() => {
      return getClientBrandingLogo(isDarkMode.value)
        ?? (isDarkMode.value
          ? require('@/assets/img/logo-2.svg')
          : require('@/assets/img/logo-1.svg'))
    })

    onMounted(() => {
      DrawerComponent.reinitialization()
      ToggleComponent.reinitialization()

      // Check initial dark mode state
      checkDarkMode()

      // Watch for theme changes
      const observer = new MutationObserver(() => {
        checkDarkMode()
      })

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      })
    })

    onUpdated(() => {
      ToggleComponent.bootstrap()
    })

    const closeMobileMenu = () => {
      const aside = document.getElementById('kt_aside')
      if (aside) {
        DrawerComponent.getInstance(aside)?.hide()
      }
    }

    return { t, closeMobileMenu, logoSrc }
  },
  data() {
    return {
      hasRole
    }
  },
})
</script>
